<div class="dialog-root">

    <div class="dialog-header">
        <div>
            <h2 class="title">Histórico de Notificações</h2>
            <p class="subtitle">Todas as notificações recebidas no sistema</p>
        </div>

        <button class="btn" aria-label="Fechar" (click)="close()">
            <i-lucide name="x"></i-lucide>
        </button>
    </div>

    <div class="dialog-body">

        <div class="history-card" *ngFor="let notificacoes of notifications">
            <div class="left">
                <span class="status-icon" [ngClass]="notificacoes.type">

                    <i-lucide *ngIf="notificacoes.type === 'success'" name="circle-check-big" size="18">
                    </i-lucide>

                    <i-lucide *ngIf="notificacoes.type === 'warning'" name="circle-alert" size="18">
                    </i-lucide>

                    <i-lucide *ngIf="notificacoes.type === 'danger'" name="circle-alert" size="18">
                    </i-lucide>

                    <i-lucide *ngIf="notificacoes.type === 'info'" name="circle-alert" size="18">
                    </i-lucide>

                </span>
            </div>

            <div class="mid">
                <div class="title-row">
                    <span class="item-title">{{ notificacoes.title }}</span>

                    <span class="tag" [ngClass]="notificacoes.type">
                        {{ notificacoes.typeLabel }}
                    </span>
                </div>

                <p class="item-subtitle">{{ notificacoes.subtitle }}</p>

                <p class="item-text">{{ notificacoes.text }}</p>

                <div class="meta-row">
                    <span>{{ notificacoes.date }}</span>
                    <span>{{ notificacoes.time }}</span>

                    <button *ngIf="notificacoes.hasDetails" (click)="abrirDetalhes(notificacoes)" type="button"
                        class="details">
                        Ver detalhes
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>